var MinicartActions = /** @class */ (function () {
    function MinicartActions(pubSubManager) {
        this.pubSubManager = pubSubManager;
    }
    MinicartActions.prototype.showMinicart = function () {
        this.pubSubManager.publish('Minicart.Show', null);
    };
    MinicartActions.prototype.hideMinicart = function () {
        this.pubSubManager.publish('Minicart.Hide', null);
    };
    return MinicartActions;
}());
export { MinicartActions };
//# sourceMappingURL=MinicartActions.js.map